module.exports = __webpack_public_path__ + "static/img/youxiaClick.8efa84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/youxiaClick.png
// module id = 3DGx
// module chunks = 0